/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Types/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import InApp from './InApp/index'
import Internal from './Internal/index'
import No from './No/index'
import React from 'react'
import Sms from './Sms/index'
import Status from './Status/index'
import Timeline from './Timeline/index'



/** @type {import('Simple/types.js').View} */
export default function Types({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventTypeValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Timeline'}>
<Timeline
  viewPath={`${viewPath}/Timeline`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Status'}>
<Status
  viewPath={`${viewPath}/Status`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Sms'}>
<Sms
  viewPath={`${viewPath}/Sms`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InApp'}>
<InApp
  viewPath={`${viewPath}/InApp`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Internal'}>
<Internal
  viewPath={`${viewPath}/Internal`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}